import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  errorCode: null,
  caseExample: {},
  printingCaseExample: false,
};

export const caseExamplesDetailsSlice = createSlice({
  name: "caseExamplesDetails",
  initialState,
  reducers: {
    caseExamplesDetailsStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    caseExamplesDetailsSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      caseExample: action.payload,
    }),
    caseExamplesDetailsFailure: (state, action) => ({
      ...state,
      loading: false,
      error: true,
      errorCode: action.payload,
    }),
    setPrintingCaseExample: (state, action) => ({
      ...state,
      printingCaseExample: action.payload,
    }),
    resetCaseExamplesDetails: () => ({
      ...initialState
    }),
    updateCaseExamplesDetails: (state, action) => ({
      ...state,
      caseExample: action.payload,
    }),
},
});

export const { 
  caseExamplesDetailsStart,
  caseExamplesDetailsSuccess,
  caseExamplesDetailsFailure,
  setPrintingCaseExample,
  resetCaseExamplesDetails,
  updateCaseExamplesDetails,
} = caseExamplesDetailsSlice.actions;

export const getCaseExamplesDetailsInfo = ({ caseExampleId }) => (dispatch) => {
  dispatch(caseExamplesDetailsStart());
  const apiPath =  `${Constants.API.CASE_EXAMPLES}/${caseExampleId}`;
  apiService.get(apiPath).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0 && data?.data?.id) {
        dispatch(caseExamplesDetailsSuccess(data?.data));
      } else {
        dispatch(caseExamplesDetailsFailure());
      }
    } else {
      dispatch(caseExamplesDetailsFailure());
    }
  }).catch((error) => {
    dispatch(caseExamplesDetailsFailure(error?.response?.status));
  })
};

export default caseExamplesDetailsSlice.reducer;
